import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AttioObjectDataset } from 'app/model/dataset/attio.dataset';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';

@Metamodel.model({
    name: 'AttioSource',
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(AttioObjectDataset)
    }
})
export class AttioCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly PAGE_SIZE: IAttribute;

    @Metamodel.attribute({
        association: 'PAGE_SIZE',
        display: stringResources.PageSizeLabel,
        templatable: true,
        accepts: ['Int'],
        constraint: {
            whole: true,
            minimum: 1
        }
    })
    public pageSize?: number = 50;
}
